/*************************************************/
/* COUNTER                                       */
/*************************************************/

import "velocity-animate";

export class counter {
    constructor(element) {
        if (element) {
            element.velocity(
                {
                    tween: [element.getAttribute('data-value'), 0]
                },
                {
                    easing: "easeOutCirc",
                    delay: 800,
                    duration: 3000,
                    progress: function (elements, complete, remaining, start, tweenValue) {
                        var val = tweenValue.tween || tweenValue;

                        element.innerHTML = Number(val).toLocaleString("en-GB", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        });
                    }
                });
        }
    }
}

export default new counter();